import i18next from 'i18next'

export const getNumberFormat = (options?: Intl.NumberFormatOptions) => {
	return new Intl.NumberFormat(i18next.language, options)
}

/** Mathematical modulo
 * @example mod(-10, 360) // returns 350
 */
export const mod = (value: number, n: number) => ((value % n) + n) % n
